module.exports = __webpack_public_path__ + "static/assets/a39cbf596f654d159ec3a47fac125006.svg";